import { useCallback, useContext, useEffect, useState } from "react"
import { StoreContext } from "src/contexts"
import CommonService from "src/services/CommonService"
import RoleService from "src/services/RoleService"
import UserService from "src/services/UserService"
import signalRService from "../../../components/SocketWrapper/index"
import STORAGE, { getStorage, setStorage } from "../../../lib/storage"
import { useAppDispatch } from "../../../redux/hooks"
import {
  getListSystemKey,
  setListTabs,
  setNumberNotify,
  setUserInfo,
} from "../../../redux/slices/appGlobalSlide"

const DefaultAction = ({ children }) => {
  const isLogin = getStorage(STORAGE.TOKEN)
  const { loginStore, userStore } = useContext(StoreContext)
  const { isLoginContext, setIsLoginContext } = loginStore
  const [log, setLog] = useState("")
  const { user, setUser } = userStore
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)

  const getUserInfo = async () => {
    try {
      setLoading(true)
      const res = await UserService.getInforUser()
      if (res.IsError) return
      dispatch(setUserInfo(res?.Object))
    } catch (error) {
      console.log("Error>>DefaultAction>>getUserInfo: ", error)
    } finally {
      setLoading(false)
    }
  }

  const getListTab = async () => {
    try {
      setLoading(true)
      const resp = await RoleService.getListTab()
      if (resp.isOk) {
        dispatch(setListTabs(resp.Object))
      }
    } catch (error) {
      console.log("Error>>DefaultAction>>getData: ", error)
    } finally {
      setLoading(false)
    }
  }

  const appendLog = useCallback(msg => {
    setLog(prev => `${new Date().toLocaleTimeString()}: ${msg}\n` + prev)
  }, [])

  const getSystemKey = async () => {
    try {
      setLoading(true)
      const res = await CommonService.getSystemKey("All")
      if (res.IsError) return
      dispatch(getListSystemKey(res.Object))
    } catch (error) {
      console.log("Error>>DefaultAction>>getSystemKey: ", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const connectToHub = async () => {
      try {
        await signalRService.startConnection()
        appendLog("✅ Kết nối thành công đến SignalR Hub")

        signalRService.on("NotifyMessage", res => {
          console.log("data", res)
          dispatch(setNumberNotify(res?.data[0]?.numberUnseen))
        })
      } catch (error) {
        appendLog("❌ Lỗi kết nối Hub: " + error)
      }
    }

    connectToHub()

    const handleHubConnect = msg => {
      alert("sadasdadasdada")
      console.log(msg)
    }
    const handleStopStream = status => {
      stopRecording() // Gọi hàm stop của component
      appendLog(`⛔ Server yêu cầu dừng: ${status}`)
    }

    // Cleanup: Hủy đăng ký sự kiện khi component unmount
    return () => {
      appendLog("🧹 Dọn dẹp các sự kiện SignalR.")
      signalRService.off("connect", handleHubConnect)
      signalRService.off("StopStream", handleStopStream)
      // Lưu ý: Không gọi stopConnection() ở đây trừ khi bạn muốn ngắt kết nối
      // hoàn toàn khi rời khỏi component này. Nếu muốn duy trì kết nối
      // cho các component khác thì bỏ qua.
      // signalRService.stopConnection();
    }
  }, [appendLog]) // Thêm appendLog vào dependency array nếu ESLint yêu cầu

  useEffect(() => {
    getSystemKey()
    setIsLoginContext(isLogin)
  }, [])

  useEffect(() => {
    const userInfo = getStorage(STORAGE.USER_INFO)
    if (userInfo) {
      setUser(userInfo)
    }
  }, [])

  useEffect(() => {
    console.log(log)
  }, [log])

  useEffect(() => {
    if (isLoginContext) {
      getListTab()
      setStorage(
        STORAGE.DEV_MODE,
        !!(typeof window !== "undefined" && window.env?.API_ROOT)?.IS_DEV,
      )
    }
  }, [isLoginContext])

  useEffect(() => {
    if (isLoginContext) {
      getUserInfo()
    }
  }, [isLoginContext])

  return <>{children}</>
}

export default DefaultAction
